import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import Link                from 'app/components/common/link';
import RteEditor           from 'app/components/common/rich-text/editor';
import StandardInput       from 'app/components/common/standard-input';
import FieldInput          from 'app/components/company-admin/forms/field-input';
import BuilderSection      from 'app/components/company-admin/layout/builder-section';
import BuilderSortableList from 'app/components/company-admin/layout/builder-sortable-list';
import helpers             from 'app/helpers/forms';
import paths               from 'app/paths';



// const fieldToLabel = (field, index) => field.title || `Field #${index+1}`;
// const fieldToIcon = (field, index) => Icon.AccountingBill;
const fieldToDetails = (field, index) => {
  const fieldObj = helpers.typeObjMap[field.type];
  return {
    label: field.title || `Field #${index+1}`,
    icon: fieldObj.icon,
    isDeleted: !!field._delete,
  };
};

class FormBuilderForm extends React.PureComponent {

  constructor(props) {
    super(props);

    this.refSortableList = React.createRef();

    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.onChangeDescription = this.onChangeDescription.bind(this);
    this.onClickAddField = this.onClickAddField.bind(this);
    this.onChangeField = this.onChangeField.bind(this);
    this.onDeleteField = this.onDeleteField.bind(this);
    this.onDeleteUndoField = this.onDeleteUndoField.bind(this);
    this.onSortFields = this.onSortFields.bind(this);
    this.renderFieldForm = this.renderFieldForm.bind(this);
  }

  get canEdit() {
    const {form, parentId} = this.props;
    if (!parentId) return true;
    return form.ownerId === parentId;
  }

  setAttrs(newAttrs) {
    const {form, onChange} = this.props;
    const newForm = {...form, ...newAttrs};
    onChange(newForm);
  }

  onChangeTitle(event) {
    const title = event.target.value;
    this.setAttrs({title});
  }

  onChangeDescription(md) {
    this.setAttrs({description: md});
  }

  onClickAddField() {
    const prevFields = this.props.form.formFields;
    const title = `Field #${prevFields.length + 1}`;
    const formFields = [...prevFields, helpers.makeNewField({title})];
    this.setAttrs({formFields});
    this.refSortableList.current?.expandLast();
  }
  onDeleteField(index) {
    const newFields = [...this.props.form.formFields];
    const newField = {...newFields[index]};
    const isNew = helpers.isNew(newField);
    if (isNew) {
      newFields.splice(index, 1);
    } else {
      newField._delete = true;
      newFields.splice(index, 1, newField);
    }
    this.setAttrs({formFields: newFields});
  }
  onDeleteUndoField(index) {
    const newFields = [...this.props.form.formFields];
    const newField = {...newFields[index]};
    delete newField._delete;
    newFields.splice(index, 1, newField);
    this.setAttrs({formFields: newFields});
  }
  onChangeField(index, field) {
    const newFields = [...this.props.form.formFields];
    newFields.splice(index, 1, field);
    this.setAttrs({formFields: newFields});
  }
  onSortFields(formFields) {
    this.setAttrs({formFields});
    // console.log('----- onSortFields', fields);
  }

  renderNoEdit() {
    const {form, company} = this.props;
    const path = company ? paths.cadminFormsEdit(company.slug, form.id) : '#';

    return (
      <BuilderSection title="">
        <p className="cadmin-builder-section-expmsg">This is a shared form. Edit it separately <Link href={path} className="blue-pink-hover">here</Link>.</p>
      </BuilderSection>
    );
  }

  renderFieldForm(field, index) {
    return <FieldInput
      field={field}
      onChange={this.onChangeField}
      index={index}
      onDelete={this.onDeleteField}
      onDeleteUndo={this.onDeleteUndoField}
    />;
  }

  render() {
    const {form, validations} = this.props;
    if (!this.canEdit) return this.renderNoEdit();

    return (
      <>
        <BuilderSection title="Title & Description">
          <StandardInput name="title" value={form.title || ''} onChange={this.onChangeTitle} label="Title" validations={validations} />
          <RteEditor initialMd={form.description || ''} onChange={this.onChangeDescription} name="description" placeholder="Description, instructions, etc..." validations={validations} />
        </BuilderSection>

        <BuilderSection title="Fields">
          <BuilderSortableList
            items={form.formFields}
            getDetails={fieldToDetails}
            onChange={this.onSortFields}
            renderExpanded={this.renderFieldForm}
            onClickNew={this.onClickAddField}
            ref={this.refSortableList}
          />
        </BuilderSection>
      </>
    );
  }

}

FormBuilderForm.propTypes = {
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  company: PropTypes.object,
  validations: PropTypes.object,
  // this component is used in both:
  //   - form builder to edit the form directly
  //   - program builder where forms are nested within the program
  // if this component is used nested in program builder, then it should only allow edits if the form belongs directly to the program
  parentId: PropTypes.string,
};

FormBuilderForm.defaultProps = {
  parentId: null,
  validations: null,
};

export default FormBuilderForm;
